import { render } from "./NotFoundPage.vue?vue&type=template&id=b55837ba&scoped=true"
const script = {}

import "./NotFoundPage.vue?vue&type=style&index=0&id=b55837ba&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/2024-mcdo-gamecenter-wrapper/2024-mcdo-gamecenter-wrapper/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b55837ba"]])

export default __exports__